/* =========================================================
   VEZANO: foto da cor na galeria, rápida e sem piscar (2026-10-23)

   1) No clique na cor, a galeria vai na hora para a foto daquela cor
      (o tema esperava cerca de 0,6 s pela resposta da Shopify).
   2) Quando a Shopify responde, o tema troca a galeria inteira. A galeria
      do computador voltava para a 1ª foto (o tema só ajustava a do celular).
      Aqui a galeria nova é colocada na foto certa no mesmo instante e
      conferida mais algumas vezes, sem animação, com a miniatura certa destacada.
   3) Se o tema remontar a galeria depois que o cliente escolheu uma cor,
      ela volta para a foto dessa cor.
   Ao abrir a página fica a imagem principal do produto, como o tema faz
   (pedido de Paulo em 2026-10-25; de 2026-10-24 a 2026-10-25 abria na foto da cor marcada).
   A resposta da Shopify continua atualizando preço e estoque.
   ========================================================= */
(function () {
  if (window.__vezanoTrocaFoto) return;
  window.__vezanoTrocaFoto = true;

  var escolhida = null; // { id: mediaId, area: seção ou janela de compra rápida }

  function slidesVisiveis(slideshow) {
    return Array.prototype.slice
      .call(slideshow.querySelectorAll('slideshow-slide[data-media-id]'))
      .filter(function (s) {
        return !s.hasAttribute('hidden') || s.hasAttribute('reveal');
      });
  }

  function selecionarFoto(area, mediaId) {
    area.querySelectorAll('media-gallery slideshow-component').forEach(function (slideshow) {
      if (typeof slideshow.select !== 'function') return;

      var slides = slidesVisiveis(slideshow);
      var indice = slides.findIndex(function (s) {
        return s.getAttribute('data-media-id') === mediaId;
      });
      if (indice < 0) return;

      if (slideshow.current !== indice) {
        slideshow.select(indice, undefined, { animate: false });
      }
      marcarSlideAtual(slideshow);
    });
  }

  // A galeria nova chega com a 1ª foto marcada como visível. Deixa marcado só o
  // slide atual (como o tema faz); assim o tema destaca a miniatura certa.
  function marcarSlideAtual(slideshow) {
    var slides = slidesVisiveis(slideshow);
    var atual = slideshow.current;
    if (typeof atual !== 'number' || !slides[atual]) return;

    slides.forEach(function (s, i) {
      if (i === atual) {
        if (s.getAttribute('aria-hidden') !== 'false') s.setAttribute('aria-hidden', 'false');
        s.removeAttribute('inert');
      } else {
        if (s.getAttribute('aria-hidden') !== 'true') s.setAttribute('aria-hidden', 'true');
        if (!s.hasAttribute('inert')) s.setAttribute('inert', '');
      }
    });
  }

  // 1) Clique na cor: troca na hora
  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('variant-picker input[data-option-media-id]');
    if (!input || !input.dataset.optionMediaId) return;

    escolhida = {
      id: String(input.dataset.optionMediaId),
      area: input.closest('.shopify-section, dialog') || document
    };
    selecionarFoto(escolhida.area, escolhida.id);
  }, true);

  // 2) Galeria nova que vem da Shopify: já na foto certa
  document.addEventListener('variant:update', function (event) {
    var area = (event.target.closest && event.target.closest('.shopify-section, dialog')) || document;
    var galeria = area.querySelector('media-gallery');
    var mediaId = escolhida && escolhida.area === area
      ? escolhida.id
      : galeria && galeria.dataset.selectedMediaId;
    if (!mediaId) return;

    mediaId = String(mediaId);
    selecionarFoto(area, mediaId);
    requestAnimationFrame(function () { selecionarFoto(area, mediaId); });
    [40, 100, 180, 300, 500, 750].forEach(function (espera) {
      setTimeout(function () { selecionarFoto(area, mediaId); }, espera);
    });
  });

  // 3) O tema às vezes remonta a galeria (ao mudar o tamanho da janela, por exemplo)
  // e ela volta para a 1ª foto. Se o cliente já escolheu uma cor, volta para a foto dela.
  function reforcar(area, mediaId) {
    selecionarFoto(area, mediaId);
    [50, 150, 300, 600, 1000].forEach(function (espera) {
      setTimeout(function () { selecionarFoto(area, mediaId); }, espera);
    });
  }

  function vigiarGaleria() {
    document.querySelectorAll('.product-information').forEach(function (info) {
      var secao = info.closest('.shopify-section') || info;
      new MutationObserver(function (mudancas) {
        if (!escolhida || escolhida.area !== secao) return;
        var remontou = mudancas.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 &&
              (n.matches('media-gallery, slideshow-component') || !!n.querySelector('media-gallery, slideshow-component'));
          });
        });
        if (remontou) reforcar(escolhida.area, escolhida.id);
      }).observe(secao, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigiarGaleria);
  } else {
    vigiarGaleria();
  }
})();

/* =========================================================
   VEZANO: preço da barra fixa de compra acompanha a variante (2026-10-23)
   O tema escreve o preço da barra só ao abrir a página. Aqui ele é
   copiado do preço principal sempre que a variante muda.
   ========================================================= */
(function () {
  if (window.__vezanoPrecoBarra) return;
  window.__vezanoPrecoBarra = true;

  function atualizarPrecoBarra() {
    var alvo = document.querySelector('#md-sticky-atc .meta .price');
    var bloco = document.querySelector('.product-information .product-details product-price');
    if (!alvo || !bloco) return;

    var preco = bloco.querySelector('.price');
    if (!preco) return;
    var antigo = bloco.querySelector('.compare-at-price');

    var novoPreco = preco.textContent.trim();
    var novoAntigo = antigo ? antigo.textContent.trim() : '';

    var atualPreco = alvo.querySelector('span');
    var atualAntigo = alvo.querySelector('s');
    if (atualPreco && atualPreco.textContent.trim() === novoPreco &&
        (atualAntigo ? atualAntigo.textContent.trim() : '') === novoAntigo) return;

    var span = document.createElement('span');
    span.textContent = novoPreco;
    alvo.replaceChildren(span);
    if (novoAntigo) {
      var s = document.createElement('s');
      s.textContent = novoAntigo;
      alvo.appendChild(s);
    }
  }

  document.addEventListener('variant:update', function () {
    atualizarPrecoBarra();
    setTimeout(atualizarPrecoBarra, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', atualizarPrecoBarra);
  } else {
    atualizarPrecoBarra();
  }
})();

/* =========================================================
   VEZANO: estrelas do BK abaixo do título nos cards (2026-10-23)
   O BK injeta as estrelas no topo do card (acima da foto). Aqui elas
   vão para logo depois do título, inclusive nos cards que aparecem
   depois (filtros, carrosséis, "ver mais").
   ========================================================= */
(function () {
  if (window.__vezanoEstrelasBK) return;
  window.__vezanoEstrelasBK = true;

  function moverEstrelas() {
    document
      .querySelectorAll('product-card .collection-star-section.bk-reviews:not(.vz-estrelas-movidas)')
      .forEach(function (estrelas) {
        var card = estrelas.closest('product-card');
        var titulo = card && card.querySelector('[class*="product_title"]');
        if (!titulo) return;
        titulo.insertAdjacentElement('afterend', estrelas);
        estrelas.classList.add('vz-estrelas-movidas');
      });
  }

  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    setTimeout(function () {
      agendado = false;
      moverEstrelas();
    }, 0);
  }

  function iniciar() {
    moverEstrelas();
    new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
